import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ListService {
  constructor(private _httpClient: HttpClient) {}

  async getList(type: string): Promise<any> {
    return this._httpClient
      .get(`/list/${type}`)
      .toPromise()
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async get(id: number, type: string) {
    return this._httpClient.get(`/list/${type}/${id}`).toPromise();
  }

  async delete(id: number, type: string) {
    return this._httpClient
      .delete(`/list/${type}/${id}`)
      .toPromise()
      .then(async (response) => {
        await this.getList(type);
        return response;
      });
  }

  async create(data: any, type: string) {
    return this._httpClient
      .post(`/list/${type}`, data)
      .toPromise()
      .then(async (response) => {
        await this.getList(type);
        return response;
      });
  }

  async update(id: number, data: any, type: string) {
    return this._httpClient
      .put(`/list/${type}/${id}`, data)
      .toPromise()
      .then(async () => {
        await this.getList(type);
      });
  }
}
